/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MTMOFilter } from '../model/mTMOFilter';
import { Response } from '../model/response';
import { ServiceCompleteRequirementsDto } from '../model/serviceCompleteRequirementsDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MTMOFilterService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mTMOFilterAddMTMOFilter(model: MTMOFilter, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public mTMOFilterAddMTMOFilter(model: MTMOFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public mTMOFilterAddMTMOFilter(model: MTMOFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public mTMOFilterAddMTMOFilter(model: MTMOFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling mTMOFilterAddMTMOFilter.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/MTMOFilter/create`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mTMOFilterCreateAllDetailsForRelayService(model: ServiceCompleteRequirementsDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public mTMOFilterCreateAllDetailsForRelayService(model: ServiceCompleteRequirementsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public mTMOFilterCreateAllDetailsForRelayService(model: ServiceCompleteRequirementsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public mTMOFilterCreateAllDetailsForRelayService(model: ServiceCompleteRequirementsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling mTMOFilterCreateAllDetailsForRelayService.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/MTMOFilter/createalldetailsforrelayservice`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mTMOFilterCreateTwoWayMTMOFilter(model: MTMOFilter, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public mTMOFilterCreateTwoWayMTMOFilter(model: MTMOFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public mTMOFilterCreateTwoWayMTMOFilter(model: MTMOFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public mTMOFilterCreateTwoWayMTMOFilter(model: MTMOFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling mTMOFilterCreateTwoWayMTMOFilter.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/api/MTMOFilter/createtwowayroute`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mTMOFilterDeleteMTMOFilter(model: MTMOFilter, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public mTMOFilterDeleteMTMOFilter(model: MTMOFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public mTMOFilterDeleteMTMOFilter(model: MTMOFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public mTMOFilterDeleteMTMOFilter(model: MTMOFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling mTMOFilterDeleteMTMOFilter.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<number>(`${this.basePath}/api/MTMOFilter/delete`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param shortcode 
     * @param mnc 
     * @param keyword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mTMOFilterDeleteMTMOFilter2(creatorId?: string, shortcode?: string, mnc?: string, keyword?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public mTMOFilterDeleteMTMOFilter2(creatorId?: string, shortcode?: string, mnc?: string, keyword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public mTMOFilterDeleteMTMOFilter2(creatorId?: string, shortcode?: string, mnc?: string, keyword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public mTMOFilterDeleteMTMOFilter2(creatorId?: string, shortcode?: string, mnc?: string, keyword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (shortcode !== undefined && shortcode !== null) {
            queryParameters = queryParameters.set('shortcode', <any>shortcode);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<number>(`${this.basePath}/api/MTMOFilter/deleteMTMOFilter`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shortCode 
     * @param smsRouteName 
     * @param mcc 
     * @param mnc 
     * @param mobileType 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mTMOFilterGetAllMTMOFilters(shortCode?: string, smsRouteName?: string, mcc?: string, mnc?: string, mobileType?: number, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<MTMOFilter>>;
    public mTMOFilterGetAllMTMOFilters(shortCode?: string, smsRouteName?: string, mcc?: string, mnc?: string, mobileType?: number, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MTMOFilter>>>;
    public mTMOFilterGetAllMTMOFilters(shortCode?: string, smsRouteName?: string, mcc?: string, mnc?: string, mobileType?: number, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MTMOFilter>>>;
    public mTMOFilterGetAllMTMOFilters(shortCode?: string, smsRouteName?: string, mcc?: string, mnc?: string, mobileType?: number, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }
        if (smsRouteName !== undefined && smsRouteName !== null) {
            queryParameters = queryParameters.set('smsRouteName', <any>smsRouteName);
        }
        if (mcc !== undefined && mcc !== null) {
            queryParameters = queryParameters.set('mcc', <any>mcc);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }
        if (mobileType !== undefined && mobileType !== null) {
            queryParameters = queryParameters.set('mobileType', <any>mobileType);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MTMOFilter>>(`${this.basePath}/api/MTMOFilter/getall`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shortCodePhoneNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mTMOFilterGetMOMTFilterByShortCodePhoneNumber(shortCodePhoneNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<MTMOFilter>;
    public mTMOFilterGetMOMTFilterByShortCodePhoneNumber(shortCodePhoneNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MTMOFilter>>;
    public mTMOFilterGetMOMTFilterByShortCodePhoneNumber(shortCodePhoneNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MTMOFilter>>;
    public mTMOFilterGetMOMTFilterByShortCodePhoneNumber(shortCodePhoneNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortCodePhoneNumber !== undefined && shortCodePhoneNumber !== null) {
            queryParameters = queryParameters.set('shortCodePhoneNumber', <any>shortCodePhoneNumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MTMOFilter>(`${this.basePath}/api/MTMOFilter/getmtmofilterbyshortcode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mTMOFilterGetMTMOFilterById(id?: string, observe?: 'body', reportProgress?: boolean): Observable<MTMOFilter>;
    public mTMOFilterGetMTMOFilterById(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MTMOFilter>>;
    public mTMOFilterGetMTMOFilterById(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MTMOFilter>>;
    public mTMOFilterGetMTMOFilterById(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MTMOFilter>(`${this.basePath}/api/MTMOFilter/getbyid`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param mTMOFilter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mTMOFilterUpdateMTMOFilter(mTMOFilter: MTMOFilter, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public mTMOFilterUpdateMTMOFilter(mTMOFilter: MTMOFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public mTMOFilterUpdateMTMOFilter(mTMOFilter: MTMOFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public mTMOFilterUpdateMTMOFilter(mTMOFilter: MTMOFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (mTMOFilter === null || mTMOFilter === undefined) {
            throw new Error('Required parameter mTMOFilter was null or undefined when calling mTMOFilterUpdateMTMOFilter.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/MTMOFilter/update`,
            mTMOFilter,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
